import React, { useState, useEffect } from "react";
import SubHead from "../SubHead";
import imgList01 from "../../../assets/img_board_list.png";
import { Link } from "react-router-dom";

import PagingView from "../../../component/PagingView";

import { GetList } from "../../../lib/Board";
import moment from "moment";

const Gallery = () => {
    const [years, setYears] = useState([]);
    const [items, setItems] = useState([]);
    const [data, setData] = useState({
        page: 1,
        size: 30,
        sort: "-id",
        board: "ad",
        title: "",
        year: ""
    });

    const [range, setRange] = useState({
        end: 0,
        size: 1,
        start: 0,
        total: 1
    });

    useEffect(() => {
        for (var i = moment().format("YYYY"); i >= 2021; i--) {
            years.push(i);
        }
        setYears(years);

        reloadList(1);
    }, []);

    const reloadList = page => {
        data.page = page;
        setData(data);
        GetList(data, resultList);
    };

    /**
     * 리스트
     */
    const resultList = response => {
        setItems(response.rows);
        setRange(response.range);
    };

    return (
        <>
            <SubHead title="공시/홍보" eng="NOTICE"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="sub_tab_wrap">
                        <ul className="sub_tab">
                            <li>
                                <Link to={"/promotion/board/list"}>
                                    <a href="#">공시</a>
                                </Link>
                            </li>
                            <li className="on">
                                <Link to={"/promotion/board/gallery"}>
                                    <a href="#">홍보</a>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <form className="search-form">
                        <label>검색</label>
                        <select
                            value={data.year}
                            onChange={e => {
                                data.year = e.target.value;
                                setData({ ...data });
                            }}
                        >
                            <option key={""}>년도별</option>
                            {years.map(x => (
                                <option key={x}>{x}</option>
                            ))}
                        </select>
                        <input
                            type="text"
                            placeholder="검색어를 입력하세요"
                            value={data.title}
                            onChange={e => {
                                data.title = e.target.value;
                                setData({ ...data });
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => {
                                reloadList(1);
                            }}
                        >
                            검색
                        </button>
                    </form>

                    <div className="board-list-top">
                        <p className="total">
                            Total {range.total}건 {Math.ceil(Number(range.total) / Number(range.size))}페이지
                        </p>
                    </div>

                    <div className="board-gallery-wrap">
                        <ul>
                            {items.map(x => (
                                <li>
                                    <Link to={`/promotion/board/info/${data.board}/${x.id}`}>
                                        {/* <a href="#"> */}
                                            <div className="img_box">{x.uploadFiles && x.uploadFiles.length && <img src={x.uploadFiles[0].url} alt="이미지" />}</div>
                                            <p className="sbj">{x.title}</p>
                                            <p className="cont">{x.contents.replace(/(<([^>]+)>)/gi, "")}</p>
                                            <p className="date">{moment(x.createdAt).format("YYYY.MM.DD")}</p>
                                        {/* </a> */}
                                    </Link>
                                </li>
                            ))}

                            {/* <li>
                                <a href="#">
                                    <div className="img_box">
                                        <img src={imgList01} alt="이미지" />
                                    </div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="img_box"></div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="img_box"></div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="img_box"></div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="img_box"></div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="img_box"></div>
                                    <p className="sbj">7월 노사공동 사랑의 밥퍼 행사 진행</p>
                                    <p className="cont">ktMOS 북부는 7월노사 공동 사랑의 밥퍼 행사를 추진하였습니다. 7월 12일, 7월 30일 월 2회 동안 평소 남을 위한 봉사에 관심이 많남을 위한 봉사에 관심이</p>
                                    <p className="date">2022.12.01</p>
                                </a>
                            </li> */}
                        </ul>
                    </div>

                    {/* <div className="board-btns">
                        <button type="button" className="btn_nor red-line">
                            글쓰기
                        </button>
                    </div> */}

                    <PagingView nowPage={Number(data.page)} totalPage={Math.ceil(Number(range.total) / Number(range.size))} reload={reloadList} />
                </div>
            </main>
        </>
    );
};

export default Gallery;
